import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../shared/services/user.service';
import { UserRegistration } from '../../../shared/models/user.registration.interface';
import { finalize } from 'rxjs';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { FormsModule, NgForm } from '@angular/forms';
import { NgIf } from '@angular/common';

@Component({
  standalone:true,
  imports:[SpinnerComponent,FormsModule, NgIf],
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.css']
})
export class RegistrationFormComponent implements OnInit  {

  errors!: string;  
  isRequesting!: boolean;
  submitted: boolean = false;

  constructor(private userService: UserService,private router: Router) { }

  ngOnInit() {
  }

  registerUser({ value, valid }: { value: UserRegistration, valid: boolean }) {
    this.submitted = true;
    this.isRequesting = true;
    this.errors='';
    if(valid)
    {
        this.userService.register(value.email,value.password,value.firstName,value.lastName,value.location)
                  .pipe(finalize(() => this.isRequesting = false))
                  .subscribe(
                    result  => {if(result){
                        this.router.navigate(['/account/login'],{queryParams: {brandNew: true,email:value.email}});                         
                    }},
                    errors =>  this.errors = errors);
    }      
 } 

   

}
